module.exports = __webpack_public_path__ + "static/media/happy_emoji.68625470.svg";